import { mockBasketItemOffer } from '@domgen/dgx-fe-basket';
import { CheckoutCompletedOffer } from '../../models/checkout-completed-item/checkout-completed-offer.interface';
import { mockCheckoutCompletedOfferConfirmation } from './checkout-completed-offer-confirmation.mock';

export const mockCheckoutCompletedOffer: CheckoutCompletedOffer = {
  item: mockBasketItemOffer,
  confirmation: mockCheckoutCompletedOfferConfirmation,
};
